import { Avatar } from "@/components/ui/avatar";
import ApplicationSwitcher from "@/components/shell/application-switcher";
import { useAuthStore } from "@/stores/auth-store";
import { useBranding } from "@/hooks/use-branding";

/**
 * White-label client logo, shown before the app switcher: <ClientLogo> |
 * <ApplicationSwitcher>. The logo comes from the real org branding config
 * (Settings → Org Profile → Logo URL); falls back to an org-initials
 * avatar — the same treatment `sidebar.tsx`'s footer already uses for the
 * same org — when no logo URL is configured, rather than a placeholder
 * brand mark.
 */
export default function ClientLogo() {
  const { logoUrl } = useBranding();
  const orgLabel = useAuthStore((s) => s.experience.activeOrganization.label);
  const orgInitials =
    orgLabel
      .replace(/[^A-Za-z0-9 ]/g, "")
      .split(/\s+/)
      .filter(Boolean)
      .slice(0, 2)
      .map((w) => w[0])
      .join("")
      .toUpperCase() || "—";

  return (
    <div className="flex min-w-0 shrink items-center gap-2.5">
      <span
        className="grid size-10 shrink-0 place-items-center overflow-hidden rounded border border-line bg-bg p-[3px]"
        aria-hidden
      >
        {logoUrl ? (
          <img src={logoUrl} alt="" className="size-full object-contain" />
        ) : (
          <Avatar initials={orgInitials} bgColor="var(--ads-org-avatar)" size={32} fontSize={12} />
        )}
      </span>
      <span className="h-5 w-px shrink-0 bg-line" aria-hidden />
      <ApplicationSwitcher />
    </div>
  );
}
